/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { TTableColumnCell } from '../../../types';
import TableCell from '../TableCell';
import TableCellNoValue from '../TableCellNoValue';
import StatusCell from './StatusCell';
import { TTableCellStatus } from './types';

function TableCellStatus<D extends object>(cell: TTableCellStatus<D>): Pick<TTableColumnCell<D>, 'Cell'> {

    return {
        Cell: props => TableCell(props)({
            render: ({ row }) => {
                const { status, icon } = cell(row);
                return !!status
                    ? <StatusCell icon={icon} status={status} />
                    : <TableCellNoValue/>;
            },
        }),
    };
}

export default TableCellStatus;
